import { useMemo } from "react";
import useOrganisation from "contexts/OrganisationContext/useOrganisation";
import type { SubscriptionDetails } from "types/organisation";

/**
 * Custom hook to get the organisation's subscription details.
 */
function useSubscription(): SubscriptionDetails | null {
  const organisation = useOrganisation();
  return useMemo(() => organisation.subscriptionDetails || null, [organisation]);
}

export default useSubscription;
